var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlipbuttonwithinimagecapture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 11.875C14.375 12.2065 14.2433 12.5245 14.0089 12.7589C13.7745 12.9933 13.4565 13.125 13.125 13.125H1.875C1.54348 13.125 1.22554 12.9933 0.991117 12.7589C0.756696 12.5245 0.625 12.2065 0.625 11.875V5C0.625 4.66848 0.756696 4.35054 0.991117 4.11612C1.22554 3.8817 1.54348 3.75 1.875 3.75H4.375L5.625 1.875H9.375L10.625 3.75H13.125C13.4565 3.75 13.7745 3.8817 14.0089 4.11612C14.2433 4.35054 14.375 4.66848 14.375 5V11.875Z",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.625C8.88071 10.625 10 9.50571 10 8.125C10 6.74429 8.88071 5.625 7.5 5.625C6.11929 5.625 5 6.74429 5 8.125C5 9.50571 6.11929 10.625 7.5 10.625Z",
    stroke: "black",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipbuttonwithinimagecapture);
export default __webpack_public_path__ + "static/media/flip button within image capture.18a2d7dc65e77dc36e1552a9f8fa30c0.svg";
export { ForwardRef as ReactComponent };